import React from "react";
import styles from "./pdp-shimmer.module.scss";

const PDPShimmer = () => {
  return (
    <div className={styles["container"]} data-test-id="pdp-shimmer">
      <div className={styles["shimmer-block"]}></div>
      <div className={styles["shimmer-block"]}></div>
      <div className={styles["small-shimmer-block"]}></div>
      <div className={styles["tiny-shimmer-block"]}></div>
      <div className={styles["shimmer-animation"]}></div>
    </div>
  );
};

export default PDPShimmer;
